import Referral3D from "@/assets/images/3d-illus/my-referral-person-extra.png";
import { Image, View } from "@/components/ui";
import { ImageBackground } from "@/components/ui/image-background";
import ReferralBackground from "@/assets/images/background-theme/referral-background.png";
import { useSafeAreaInsets } from "@/components/hooks/use-safe-area-insets";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { useRoute } from "@/components/shared/router";
import { ReferralSectionActionCard } from "./referral-section-action-card";
import { getBackgroundTheme } from "@/containers/homepage/lib";
import { useClientReferralCodeQuery } from "@/gqlhooks/client/useClientReferralCodeQuery";

export function ReferralSectionHero() {
  const { code, loading } = useClientReferralCodeQuery();
  const { top } = useSafeAreaInsets();
  const { pull } = useRoute();
  const { isMobile } = useWindowDimensions();
  return (
    <ImageBackground
      src={isMobile ? getBackgroundTheme() : ReferralBackground} // fulfilling figma expectation
      className="relative rounded-b-3xl"
      gap={0}
      style={{
        paddingTop: top,
      }}
    >
      <View className="native:flex flex-row items-center gap-4 py-2 web:hidden">
        <IconButton
          variant="ghost"
          color="white"
          iconName="arrowLeft"
          rounded="full"
          className="p-0 md:hidden"
          onClick={() => pull()}
        />
        <Typography variant="label-md" color="white">
          My Referral
        </Typography>
      </View>
      <View className="flex flex-row items-center gap-0 pb-9">
        <View className="flex flex-1 flex-col gap-1">
          <Typography variant="h3" color="white">
            Give $15, Get $15
          </Typography>
          <Typography variant="body-sm" color="white">
            Every friend you refer gets $15 off their first booking and you get
            $15
          </Typography>
        </View>
        <Image src={Referral3D} alt="Referral Icon" width={164} height={126} />
      </View>
      <ReferralSectionActionCard referralCode={code || ""} loading={loading} />
    </ImageBackground>
  );
}
